import React from "react";
import { stddatetime, displayTransferRecipient } from "../utils/utils";

// Group header + detail-row card. The h3 stays an h3: the Cypress suite reads
// `cy.get("h3").last()` for "Transfer details".
const TransferDetails = (transfer) => {
  const isPushToAccount = transfer.recipient?.type === "pushtoaccount";
  const isRequestForPay = transfer.originated_as_rfp === true;
  // `outgoing` is the viewer-side direction. For RfP:
  //   - outgoing=true → this user is the REQUESTER (money flows toward them)
  //   - outgoing=false → this user is the REQUESTEE (they're being asked to pay)
  const isRequester = isRequestForPay && transfer.outgoing === true;
  const isRequestee = isRequestForPay && transfer.outgoing === false;
  // "+" only when the requester has actually received the funds.
  const isIncomingCredit = isRequester && transfer.status === "SUCCEEDED";

  const row = (label, value, extra = {}) => (
    <div className="np-detail-row">
      <span className="np-detail-label">{label}</span>
      <span className="np-detail-value" {...extra}>
        {value}
      </span>
    </div>
  );

  return (
    <div>
      <h3 className="np-group-header">
        {isRequestForPay ? "Request details" : "Transfer details"}
      </h3>
      <div className="np-card">
        <div className="np-detail-row">
          <span className="np-detail-label">Amount</span>
          <span
            className="np-detail-value np-detail-value-strong"
            style={{ color: isIncomingCredit ? "var(--fi-accent)" : undefined }}
            data-cy="transfer_details_amount"
          >
            {isRequester ? "+" : ""}$
            {parseFloat(transfer.amount?.value).toFixed(2)}
          </span>
        </div>
        {row(
          isRequester
            ? "Requested From"
            : isRequestee
              ? "Requested By"
              : "Recipient",
          isRequestee
            ? transfer.sender_identifier ||
                transfer.sender_name ||
                "A user on this platform"
            : displayTransferRecipient(transfer.recipient, false, transfer),
          { "data-cy": "transfer_details_recipient" }
        )}
        {isPushToAccount &&
          transfer.from_account_type &&
          row(
            "From Account",
            `${transfer.from_account_type} ${transfer.from_account_number}`
          )}
        {isPushToAccount && transfer.to_routing_number && (
          <>
            {row("To Routing Number", transfer.to_routing_number)}
            {row("To Account Number", transfer.to_account_number)}
          </>
        )}
        {row("Date", stddatetime(new Date(transfer.timestamp + "Z")), {
          "data-cy": "transfer_details_date",
        })}
        {row("Comment", transfer.note, { "data-cy": "transfer_details_note" })}
        {row("Reference ID", transfer.id, {
          style: { fontSize: "13px", color: "var(--ink-muted)" },
        })}
      </div>
    </div>
  );
};

export default TransferDetails;
